(function(angular) {
    'use strict';

    angular.module('aprima-legacy-common').factory('AuthorizationService', [
        'CurrentUser',
        'ServerInfoRepository',
        AuthorizationService
    ]);

    function AuthorizationService(
        CurrentUser,
        ServerInfoRepository
    ) {

        return {
            isUserProvider : isUserProvider,
            icd10User: isIcd10User,
        };

        function isUserProvider() {
            if(ServerInfoRepository.isFeatureSupported('ProviderAuthorization')){
                var user = CurrentUser.get();

                // Right now apAuthorization uses this in apPatientContextMenu to determine whether or not to allow the user to add a charge capture.
                // In PRM, the permissions aren't filled in, so we can't determine right now whether they are a provider currently with CurrentUser service.
                // At least this won't null ref now though:
                // This will handle legacy case where it has the string value 'True', or
                // the newer case where it is actually bool true
                return user.permissions && (user.permissions.IsProvider === 'True' || user.permissions.IsProvider === true);
            }

            return true;
        }

        function isIcd10User() {
            var user = CurrentUser.get();
            // This will handle legacy case where it has the string value 'True', or
            // the newer case where it is actually bool true
            return user.permissions && (user.permissions.ICD10User === 'True' || user.permissions.ICD10User === true);
        }
    }

})(window.angular);
